webpackJsonp([241034431790084],{

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _slugify = __webpack_require__(26);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DirectoryList = function DirectoryList(_ref) {
		var document = _ref.document,
		    apiSourceUrl = _ref.apiSourceUrl;
		return _react2.default.createElement(
			'div',
			{ className: 'col-md-4', key: document.node.id },
			_react2.default.createElement(
				'div',
				{ className: 'card mb-4 box-shadow' },
				_react2.default.createElement(
					'a',
					{ href: document.node.website_url, className: 'text-dark', target: '_blank' },
					_react2.default.createElement('img', {
						src: '' + apiSourceUrl + document.node.thumbnail.url,
						className: 'card-img-top img-fluid rounded'
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'card-body text-center' },
					_react2.default.createElement(
						'div',
						{ className: 'card-text mt-3' },
						_react2.default.createElement(
							'h5',
							null,
							_react2.default.createElement(
								'a',
								{
									href: document.node.website_url,
									className: 'text-dark',
									target: '_blank'
								},
								document.node.title
							)
						),
						!document.node.free ? _react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(
								'span',
								{ className: 'badge badge-pill badge-primary' },
								'Featured'
							)
						) : _react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(
								'span',
								{ className: 'badge badge-pill badge-info' },
								'Free'
							)
						),
						_react2.default.createElement(
							'p',
							null,
							document.node.body.length > 50 ? document.node.body.substring(0, 50) + '...' : document.node.body
						)
					)
				)
			)
		);
	};
	
	exports.default = DirectoryList;
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.directoryQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _directoryList = __webpack_require__(78);
	
	var _directoryList2 = _interopRequireDefault(_directoryList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DirectoryPage = function DirectoryPage(_ref) {
		var data = _ref.data;
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'container text-center' },
				_react2.default.createElement(
					'h2',
					null,
					'Directory Page'
				),
				_react2.default.createElement(
					'p',
					null,
					'You are viewing the directory page.'
				),
				_react2.default.createElement(
					_gatsbyLink2.default,
					{ to: '/' },
					'\u2190 Go back to the homepage'
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'bg-light mt-5 pb-5' },
				_react2.default.createElement(
					'div',
					{ className: 'py-5' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'mb-5' },
							_react2.default.createElement(
								'h2',
								null,
								'Directory Page'
							),
							_react2.default.createElement(
								'p',
								null,
								'We pull the latest posts from ',
								_react2.default.createElement(
									'code',
									null,
									'Directory'
								),
								' content model using Strapi API'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							data.allStrapiDirectory.edges.map(function (d) {
								return _react2.default.createElement(_directoryList2.default, {
									apiSourceUrl: data.site.siteMetadata.apiSourceUrl,
									document: d
								});
							})
						)
					)
				)
			)
		);
	};
	
	exports.default = DirectoryPage;
	var directoryQuery = exports.directoryQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (text) {
		return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
		.replace(/[^\w\-]+/g, '') // Remove all non-word chars
		.replace(/\-\-+/g, '-') // Replace multiple - with single -
		.replace(/^-+/, '') // Trim - from start of text
		.replace(/-+$/, ''); // Trim - from end of text
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-directory-js-f1644e1df10869a5a216.js